import React, { useState, useEffect } from "react";
import { DollarSign, Calendar } from "lucide-react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

import { getDashboardData, getMonthlySales } from "../api"; // ✅ CORRECT PATH

function AnalyticsDashboard() {
  const [metrics, setMetrics] = useState({
    todaysSales: 0,
    yearlySales: 0,
  });

  const [monthlySales, setMonthlySales] = useState([]);

  useEffect(() => {
    const fetchDashboard = async () => {
      try {
        const res = await getDashboardData();

        setMetrics({
          todaysSales: res.totalSalesToday || 0,
          yearlySales: res.totalSalesYear || 0,
        });

        const monthly = await getMonthlySales();
        setMonthlySales(monthly || []);
      } catch (err) {
        console.error("Error fetching dashboard data:", err);
      }
    };

    fetchDashboard();
  }, []);

  const formatCurrency = (value) =>
    new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
    }).format(value || 0);

  return (
    <div className="space-y-8">
      <h1 className="text-2xl font-bold text-gray-900">Analytics Dashboard</h1>

      {/* Metric Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

        {/* Today Sales */}
        <div className="bg-white rounded-xl shadow-sm p-6 border-l-4 border-[#ffb319]">
          <p className="text-sm text-gray-600">Today's Sales</p>
          <p className="text-3xl font-bold">{formatCurrency(metrics.todaysSales)}</p>
          <DollarSign className="w-8 h-8 text-green-600 mt-2" />
        </div>

        {/* Yearly Sales */}
        <div className="bg-white rounded-xl shadow-sm p-6 border-l-4 border-[#ffb319]">
          <p className="text-sm text-gray-600">Yearly Sales</p>
          <p className="text-3xl font-bold">{formatCurrency(metrics.yearlySales)}</p>
          <Calendar className="w-8 h-8 text-blue-600 mt-2" />
        </div>

      </div>

      {/* Monthly Sales Trend */}
      <div className="bg-white rounded-xl shadow-sm p-6">
        <h2 className="text-lg font-semibold mb-4 text-gray-800">Monthly Sales Trend</h2>

        <ResponsiveContainer width="100%" height={300}>
          <LineChart data={monthlySales}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="month" />
            <YAxis tickFormatter={(v) => `₹${v / 1000}k`} />
            <Tooltip formatter={(value) => formatCurrency(value)} />
            <Line dataKey="sales" stroke="#ffb319" strokeWidth={3} />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}

export default AnalyticsDashboard;